{
  "user": {
    "navbar": {
      "manager": "Manager",
      "dashboard": "Dashboard",
      "logout": "Logout"
    },
    "sidebar": {
      "memberId": "Your Member ID:",
      "mySignups": "My Signups",
      "myWaitlists": "My Waitlists",
      "myBookings": "My Bookings",
      "createBooking": "Create Booking",
      "volunteering": "Volunteering",
      "viewVolunteerOpportunities": "View Volunteer Opportunities",
      "trackYourTime": "Track Your Time",
      "donate": "Donate",
      "donateNow": "Donate Now",
      "myDonations": "My Donations",
      "familyInfo": "Family Info",
      "invoices": "Invoices",
      "memberDirectory": "Member Directory",
      "myProfile": "My Profile",
      "general": "General",
      "notifications": "Notifications",
      "payment": "Payment",
      "myForms": "My Forms",
      "myWaivers": "My Waivers",
      "apiKeys": "API Keys",
      "support": "Support",
      "logout": "Logout",
      "toManagerDashboard": "To Manager Dashboard"
    }
  },
  "guest": {
    "navbar": {
      "volunteering": "Volunteering",
      "donate": "Donate",
      "login": "Login"
    },
    "sidebar": {
      "login": "Login",
      "memberships": "Memberships",
      "volunteering": "Volunteering",
      "donate": "Donate"
    }
  },
  "manager": {
    "sidebar": {
      "userDashboard": "User Dashboard",
      "dashboard": "Dashboard",
      "communalAdminOnly": "Communal Admin Only",
      "unlockThisModule": "Unlock This Module",
      "unlockModuleMessage": "This module is not available on your account. To unlock this module, email us directly at help{'@'}getcommunal.com and we will be happy to help you.",
      "people": "People",
      "users": "Users",
      "organizations": "Organizations",
      "notifications": "Notifications",
      "tags": "Tags",
      "userMemberships": "User Memberships",
      "profileFields": "Profile Fields",
      "roles": "Roles",
      "membershipTypes": "Membership Types",
      "types": "Types",
      "cards": "Cards",
      "settings": "Settings",
      "programs": "Programs",
      "allPrograms": "All Programs",
      "customFields": "Custom Fields",
      "attendanceSheets": "Attendance Sheets",
      "facilities": "Facilities",
      "calendar": "Calendar",
      "allBookings": "All Bookings",
      "myFacilities": "My Facilities",
      "lockerRooms": "Locker Rooms",
      "volunteering": "Volunteering",
      "allSignups": "All Signups",
      "allOpportunities": "All Opportunities",
      "volunteerHours": "Volunteer Hours",
      "volunteerSettings": "Volunteer Settings",
      "scanInOut": "Scan In/Out",
      "donations": "Donations",
      "allDonations": "All Donations",
      "fundraisers": "Fundraisers",
      "pointOfSale": "Point of Sale",
      "posToken": "POS Token",
      "products": "Products",
      "categories": "Categories",
      "tools": "Tools",
      "invoices": "Invoices",
      "charges": "Charges",
      "waivers": "Waivers",
      "banners": "Banners",
      "forms": "Forms",
      "discountCodes": "Discount Codes",
      "fees": "Fees",
      "reporting": "Reporting",
      "dailyReport": "Daily Report",
      "memberships": "Memberships",
      "transactionList": "Transaction List",
      "payoutReports": "Payout Reports",
      "general": "General",
      "appearance": "Appearance",
      "billing": "Billing",
      "padBankVerification": "PAD Bank Verification",
      "actions": "Actions",
      "boundaries": "Boundaries",
      "taxes": "Taxes",
      "customNotifications": "Custom Notifications",
      "welcomeEmail": "Welcome Email",
      "customText": "Custom Text",
      "userImport": "User Import",
      "pollingSettings": "Polling Settings",
      "integrations": "Integrations",
      "viewCards": "View Cards",
      "membershipCards": "Membership Cards",
      "communications": "Communications"
    }
  }
}
